import { render, staticRenderFns } from "./newListUploadedFiles.vue?vue&type=template&id=1287f046&scoped=true&"
import script from "./newListUploadedFiles.vue?vue&type=script&lang=js&"
export * from "./newListUploadedFiles.vue?vue&type=script&lang=js&"
import style0 from "./newListUploadedFiles.vue?vue&type=style&index=0&id=1287f046&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287f046",
  null
  
)

export default component.exports